<template>
    <b-form-group label-for="country">
        <template slot="label"
            >{{ $t("pages.forms.common.country")
            }}<span v-if="required" class="font-weight-bolder text-danger"
                >*</span
            ></template
        >
        <validation-provider
            :rules="{ required }"
            v-slot="{ dirty, classes, valid, validated, errors }"
        >
            <multiselect
                id="country"
                v-model="country"
                :options="countryOptions"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="false"
                label="text"
                track-by="text"
                :taggable="true"
                :placeholder="$t('pages.forms.select-descriptors.placeholder')"
                :deselectLabel="
                    $t('pages.forms.select-descriptors.deselectlabel')
                "
                :selectedLabel="
                    $t('pages.forms.select-descriptors.selectedlabel')
                "
                :selectLabel="$t('pages.forms.select-descriptors.selectlabel')"
                :showLabels="false"
                openDirection="above"
                :class="classes"
                :maxHeight="350"
                @input="update"
                v-show="!isReviewing"
                data-cypress-id="country-test"
            />
            <div v-if="(dirty || validated) && !valid" class="invalid-feedback">
                {{ errors[0] }}
            </div>
        </validation-provider>
        <b-form-input
            type="text"
            readonly
            plaintext
            v-show="isReviewing"
            :value="countryValue"
        />
    </b-form-group>
</template>

<script>
import FormInputHelpers from "../../../mixins/FormInputHelpers";
import { ValidationProvider } from "vee-validate";

export default {
    mixins: [FormInputHelpers],
    components: { ValidationProvider },
    data() {
        return {
            country: this.value.country
        };
    },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    country: {
                        text: null,
                        code: null
                    }
                };
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        reviewing: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update() {
            this.$emit("input", this.country);
        }
    },
    computed: {
        isReviewing() {
            return this.reviewing;
        },
        countryValue() {
            if (this.country != null) {
                return this.country.text;
            }
            return this.country;
        },
        countryOptions() {
            return [
                { text: this.$t("countries.af"), value: "af" },
                { text: this.$t("countries.al"), value: "al" },
                { text: this.$t("countries.de"), value: "de" },
                { text: this.$t("countries.ad"), value: "ad" },
                { text: this.$t("countries.ao"), value: "ao" },
                { text: this.$t("countries.ai"), value: "ai" },
                { text: this.$t("countries.aq"), value: "aq" },
                { text: this.$t("countries.ag"), value: "ag" },
                { text: this.$t("countries.an"), value: "an" },
                { text: this.$t("countries.sa"), value: "sa" },
                { text: this.$t("countries.dz"), value: "dz" },
                { text: this.$t("countries.ar"), value: "ar" },
                { text: this.$t("countries.am"), value: "am" },
                { text: this.$t("countries.aw"), value: "aw" },
                { text: this.$t("countries.au"), value: "au" },
                { text: this.$t("countries.at"), value: "at" },
                { text: this.$t("countries.az"), value: "az" },
                { text: this.$t("countries.bs"), value: "bs" },
                { text: this.$t("countries.bd"), value: "bd" },
                { text: this.$t("countries.bb"), value: "bb" },
                { text: this.$t("countries.bh"), value: "bh" },
                { text: this.$t("countries.be"), value: "be" },
                { text: this.$t("countries.bz"), value: "bz" },
                { text: this.$t("countries.bj"), value: "bj" },
                { text: this.$t("countries.bm"), value: "bm" },
                { text: this.$t("countries.by"), value: "by" },
                { text: this.$t("countries.bo"), value: "bo" },
                { text: this.$t("countries.bq"), value: "bq" },
                { text: this.$t("countries.ba"), value: "ba" },
                { text: this.$t("countries.bw"), value: "bw" },
                { text: this.$t("countries.br"), value: "br" },
                { text: this.$t("countries.bn"), value: "bn" },
                { text: this.$t("countries.bg"), value: "bg" },
                { text: this.$t("countries.bf"), value: "bf" },
                { text: this.$t("countries.bi"), value: "bi" },
                { text: this.$t("countries.bt"), value: "bt" },
                { text: this.$t("countries.cv"), value: "cv" },
                { text: this.$t("countries.kh"), value: "kh" },
                { text: this.$t("countries.cm"), value: "cm" },
                { text: this.$t("countries.ca"), value: "ca" },
                { text: this.$t("countries.qa"), value: "qa" },
                { text: this.$t("countries.td"), value: "td" },
                { text: this.$t("countries.cl"), value: "cl" },
                { text: this.$t("countries.cn"), value: "cn" },
                { text: this.$t("countries.cy"), value: "cy" },
                { text: this.$t("countries.co"), value: "co" },
                { text: this.$t("countries.km"), value: "km" },
                { text: this.$t("countries.kp"), value: "kp" },
                { text: this.$t("countries.kr"), value: "kr" },
                { text: this.$t("countries.ci"), value: "ci" },
                { text: this.$t("countries.cr"), value: "cr" },
                { text: this.$t("countries.hr"), value: "hr" },
                { text: this.$t("countries.cu"), value: "cu" },
                { text: this.$t("countries.cw"), value: "cw" },
                { text: this.$t("countries.dk"), value: "dk" },
                { text: this.$t("countries.dm"), value: "dm" },
                { text: this.$t("countries.ec"), value: "ec" },
                { text: this.$t("countries.eg"), value: "eg" },
                { text: this.$t("countries.sv"), value: "sv" },
                { text: this.$t("countries.ae"), value: "ae" },
                { text: this.$t("countries.er"), value: "er" },
                { text: this.$t("countries.sk"), value: "sk" },
                { text: this.$t("countries.si"), value: "si" },
                { text: this.$t("countries.es"), value: "es" },
                { text: this.$t("countries.us"), value: "us" },
                { text: this.$t("countries.ee"), value: "ee" },
                { text: this.$t("countries.et"), value: "et" },
                { text: this.$t("countries.fj"), value: "fj" },
                { text: this.$t("countries.ph"), value: "ph" },
                { text: this.$t("countries.fi"), value: "fi" },
                { text: this.$t("countries.fr"), value: "fr" },
                { text: this.$t("countries.ga"), value: "ga" },
                { text: this.$t("countries.gm"), value: "gm" },
                { text: this.$t("countries.ge"), value: "ge" },
                { text: this.$t("countries.gh"), value: "gh" },
                { text: this.$t("countries.gi"), value: "gi" },
                { text: this.$t("countries.gd"), value: "gd" },
                { text: this.$t("countries.gr"), value: "gr" },
                { text: this.$t("countries.gl"), value: "gl" },
                { text: this.$t("countries.gp"), value: "gp" },
                { text: this.$t("countries.gu"), value: "gu" },
                { text: this.$t("countries.gt"), value: "gt" },
                { text: this.$t("countries.gf"), value: "gf" },
                { text: this.$t("countries.gg"), value: "gg" },
                { text: this.$t("countries.gn"), value: "gn" },
                { text: this.$t("countries.gw"), value: "gw" },
                { text: this.$t("countries.gq"), value: "gq" },
                { text: this.$t("countries.gy"), value: "gy" },
                { text: this.$t("countries.ht"), value: "ht" },
                { text: this.$t("countries.hn"), value: "hn" },
                { text: this.$t("countries.hk"), value: "hk" },
                { text: this.$t("countries.hu"), value: "hu" },
                { text: this.$t("countries.in"), value: "in" },
                { text: this.$t("countries.id"), value: "id" },
                { text: this.$t("countries.iq"), value: "iq" },
                { text: this.$t("countries.ir"), value: "ir" },
                { text: this.$t("countries.ie"), value: "ie" },
                { text: this.$t("countries.bv"), value: "bv" },
                { text: this.$t("countries.im"), value: "im" },
                { text: this.$t("countries.cx"), value: "cx" },
                { text: this.$t("countries.nf"), value: "nf" },
                { text: this.$t("countries.is"), value: "is" },
                { text: this.$t("countries.ky"), value: "ky" },
                { text: this.$t("countries.cc"), value: "cc" },
                { text: this.$t("countries.ck"), value: "ck" },
                { text: this.$t("countries.ax"), value: "ax" },
                { text: this.$t("countries.fo"), value: "fo" },
                { text: this.$t("countries.gs"), value: "gs" },
                { text: this.$t("countries.hm"), value: "hm" },
                { text: this.$t("countries.fk"), value: "fk" },
                { text: this.$t("countries.mp"), value: "mp" },
                { text: this.$t("countries.mh"), value: "mh" },
                { text: this.$t("countries.um"), value: "um" },
                { text: this.$t("countries.pn"), value: "pn" },
                { text: this.$t("countries.sb"), value: "sb" },
                { text: this.$t("countries.sj"), value: "sj" },
                { text: this.$t("countries.tk"), value: "tk" },
                { text: this.$t("countries.tc"), value: "tc" },
                { text: this.$t("countries.vg"), value: "vg" },
                { text: this.$t("countries.vi"), value: "vi" },
                { text: this.$t("countries.il"), value: "il" },
                { text: this.$t("countries.it"), value: "it" },
                { text: this.$t("countries.jm"), value: "jm" },
                { text: this.$t("countries.jp"), value: "jp" },
                { text: this.$t("countries.je"), value: "je" },
                { text: this.$t("countries.jo"), value: "jo" },
                { text: this.$t("countries.kz"), value: "kz" },
                { text: this.$t("countries.ke"), value: "ke" },
                { text: this.$t("countries.kg"), value: "kg" },
                { text: this.$t("countries.ki"), value: "ki" },
                { text: this.$t("countries.xk"), value: "xk" },
                { text: this.$t("countries.kw"), value: "kw" },
                { text: this.$t("countries.la"), value: "la" },
                { text: this.$t("countries.ls"), value: "ls" },
                { text: this.$t("countries.lv"), value: "lv" },
                { text: this.$t("countries.lb"), value: "lb" },
                { text: this.$t("countries.lr"), value: "lr" },
                { text: this.$t("countries.ly"), value: "ly" },
                { text: this.$t("countries.li"), value: "li" },
                { text: this.$t("countries.lt"), value: "lt" },
                { text: this.$t("countries.lu"), value: "lu" },
                { text: this.$t("countries.mo"), value: "mo" },
                { text: this.$t("countries.mk"), value: "mk" },
                { text: this.$t("countries.mg"), value: "mg" },
                { text: this.$t("countries.my"), value: "my" },
                { text: this.$t("countries.mw"), value: "mw" },
                { text: this.$t("countries.mv"), value: "mv" },
                { text: this.$t("countries.ml"), value: "ml" },
                { text: this.$t("countries.mt"), value: "mt" },
                { text: this.$t("countries.ma"), value: "ma" },
                { text: this.$t("countries.mq"), value: "mq" },
                { text: this.$t("countries.mu"), value: "mu" },
                { text: this.$t("countries.mr"), value: "mr" },
                { text: this.$t("countries.yt"), value: "yt" },
                { text: this.$t("countries.mx"), value: "mx" },
                { text: this.$t("countries.fm"), value: "fm" },
                { text: this.$t("countries.md"), value: "md" },
                { text: this.$t("countries.mc"), value: "mc" },
                { text: this.$t("countries.mn"), value: "mn" },
                { text: this.$t("countries.me"), value: "me" },
                { text: this.$t("countries.ms"), value: "ms" },
                { text: this.$t("countries.mz"), value: "mz" },
                { text: this.$t("countries.mm"), value: "mm" },
                { text: this.$t("countries.na"), value: "na" },
                { text: this.$t("countries.nr"), value: "nr" },
                { text: this.$t("countries.np"), value: "np" },
                { text: this.$t("countries.ni"), value: "ni" },
                { text: this.$t("countries.ne"), value: "ne" },
                { text: this.$t("countries.ng"), value: "ng" },
                { text: this.$t("countries.nu"), value: "nu" },
                { text: this.$t("countries.no"), value: "no" },
                { text: this.$t("countries.nc"), value: "nc" },
                { text: this.$t("countries.nz"), value: "nz" },
                { text: this.$t("countries.om"), value: "om" },
                { text: this.$t("countries.nl"), value: "nl" },
                { text: this.$t("countries.pk"), value: "pk" },
                { text: this.$t("countries.pw"), value: "pw" },
                { text: this.$t("countries.pa"), value: "pa" },
                { text: this.$t("countries.pg"), value: "pg" },
                { text: this.$t("countries.py"), value: "py" },
                { text: this.$t("countries.pe"), value: "pe" },
                { text: this.$t("countries.pf"), value: "pf" },
                { text: this.$t("countries.pl"), value: "pl" },
                { text: this.$t("countries.pt"), value: "pt" },
                { text: this.$t("countries.pr"), value: "pr" },
                { text: this.$t("countries.gb"), value: "gb" },
                { text: this.$t("countries.cz"), value: "cz" },
                { text: this.$t("countries.cf"), value: "cf" },
                { text: this.$t("countries.cg"), value: "cg" },
                { text: this.$t("countries.cd"), value: "cd" },
                { text: this.$t("countries.do"), value: "do" },
                { text: this.$t("countries.tg"), value: "tg" },
                { text: this.$t("countries.re"), value: "re" },
                { text: this.$t("countries.rw"), value: "rw" },
                { text: this.$t("countries.ro"), value: "ro" },
                { text: this.$t("countries.ru"), value: "ru" },
                { text: this.$t("countries.eh"), value: "eh" },
                { text: this.$t("countries.as"), value: "as" },
                { text: this.$t("countries.ws"), value: "ws" },
                { text: this.$t("countries.bl"), value: "bl" },
                { text: this.$t("countries.kn"), value: "kn" },
                { text: this.$t("countries.sm"), value: "sm" },
                { text: this.$t("countries.mf"), value: "mf" },
                { text: this.$t("countries.pm"), value: "pm" },
                { text: this.$t("countries.vc"), value: "vc" },
                { text: this.$t("countries.sh"), value: "sh" },
                { text: this.$t("countries.lc"), value: "lc" },
                { text: this.$t("countries.st"), value: "st" },
                { text: this.$t("countries.sn"), value: "sn" },
                { text: this.$t("countries.rs"), value: "rs" },
                { text: this.$t("countries.cs"), value: "cs" },
                { text: this.$t("countries.sc"), value: "sc" },
                { text: this.$t("countries.sl"), value: "sl" },
                { text: this.$t("countries.sg"), value: "sg" },
                { text: this.$t("countries.sy"), value: "sy" },
                { text: this.$t("countries.so"), value: "so" },
                { text: this.$t("countries.lk"), value: "lk" },
                { text: this.$t("countries.sz"), value: "sz" },
                { text: this.$t("countries.za"), value: "za" },
                { text: this.$t("countries.sd"), value: "sd" },
                { text: this.$t("countries.ss"), value: "ss" },
                { text: this.$t("countries.se"), value: "se" },
                { text: this.$t("countries.ch"), value: "ch" },
                { text: this.$t("countries.sr"), value: "sr" },
                { text: this.$t("countries.th"), value: "th" },
                { text: this.$t("countries.tw"), value: "tw" },
                { text: this.$t("countries.tz"), value: "tz" },
                { text: this.$t("countries.tj"), value: "tj" },
                { text: this.$t("countries.io"), value: "io" },
                { text: this.$t("countries.tf"), value: "tf" },
                { text: this.$t("countries.ps"), value: "ps" },
                { text: this.$t("countries.tl"), value: "tl" },
                { text: this.$t("countries.to"), value: "to" },
                { text: this.$t("countries.tt"), value: "tt" },
                { text: this.$t("countries.tn"), value: "tn" },
                { text: this.$t("countries.tm"), value: "tm" },
                { text: this.$t("countries.tr"), value: "tr" },
                { text: this.$t("countries.tv"), value: "tv" },
                { text: this.$t("countries.ua"), value: "ua" },
                { text: this.$t("countries.ug"), value: "ug" },
                { text: this.$t("countries.uy"), value: "uy" },
                { text: this.$t("countries.uz"), value: "uz" },
                { text: this.$t("countries.vu"), value: "vu" },
                { text: this.$t("countries.va"), value: "va" },
                { text: this.$t("countries.ve"), value: "ve" },
                { text: this.$t("countries.vn"), value: "vn" },
                { text: this.$t("countries.wf"), value: "wf" },
                { text: this.$t("countries.ye"), value: "ye" },
                { text: this.$t("countries.dj"), value: "dj" },
                { text: this.$t("countries.zm"), value: "zm" },
                { text: this.$t("countries.zw"), value: "zw" }
            ];
        }
    }
};
</script>

<style scoped></style>
